import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import ApplyTemplateForm from './ApplyTemplateForm'

export class ApplyTemplate extends React.Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,

    cardId: PropTypes.number.isRequired,

    leftSidebar: PropTypes.object.isRequired,

    boardId: PropTypes.number.isRequired,

    requestApplyCardTemplate: PropTypes.func.isRequired,
  }

  handleApplyTemplateSubmit = ({ template }) => {
    const { modalId, cardId, leftSidebar, requestApplyCardTemplate } = this.props

    if (template && template !== 'empty') {
      requestApplyCardTemplate({
        cardId,
        template: { type: 'card', id: +template }
      })
    }

    leftSidebar.remove(modalId)
  }

  render () {
    const {
      boardId
    } = this.props

    return (
      <CardModalView
        title={<FormattedMessage id='CARD_APPLY_TEMPLATE_HEADER' />}
      >
        <ViewBody>
          <ApplyTemplateForm
            boardId={boardId}
            onSubmit={this.handleApplyTemplateSubmit}
          />
        </ViewBody>
      </CardModalView>
    )
  }
}

export default withLeftSidebar(ApplyTemplate)
